import { Button } from "primereact/button";
import { Message } from "primereact/message";

import { Icon } from "@/ds";
import {
  CALCULANDO_LABEL,
  COLETOR_COLUNA,
  ERRO_PREVIA_TITLE,
  TABELA_LABEL,
  TABELA_TITLE,
  TOTAL_COLUNA,
} from "./projecao-coletores-tabela.constants";
import styles from "./projecao-coletores-tabela.module.scss";
import type { ProjecaoColetoresTabelaViewModel } from "./types-projecao-coletores-tabela";

export function ProjecaoColetoresTabelaView({
  colunas,
  linhas,
  avisos,
  erro,
  calculando,
  temTabela,
  alternarCategoria,
}: ProjecaoColetoresTabelaViewModel) {
  const grade = `minmax(260px, 352px) 140px repeat(${colunas.length}, 120px) minmax(0, 1fr)`;

  return (
    <section className={styles.bloco} data-testid="projecao-coletores">
      <h2 className={styles.titulo}>{TABELA_TITLE}</h2>
      {erro ? (
        <Message
          className="p-message-block"
          severity="warn"
          text={`${ERRO_PREVIA_TITLE} ${erro}`}
          data-testid="projecao-previa-erro"
        />
      ) : null}
      {avisos.map((aviso) => (
        <Message
          key={aviso}
          className="p-message-block"
          severity="info"
          text={aviso}
          data-testid="projecao-aviso"
        />
      ))}
      {calculando ? (
        <p className={styles.nota} data-testid="projecao-calculando">
          {CALCULANDO_LABEL}
        </p>
      ) : null}
      {temTabela ? (
        <div className={styles.tabela} role="table" aria-label={TABELA_LABEL}>
          <div
            className={`${styles.linha} ${styles.cabecalho}`}
            style={{ gridTemplateColumns: grade }}
            role="row"
          >
            <span className={styles.coletor} role="columnheader">
              {COLETOR_COLUNA}
            </span>
            <span className={styles.numero} role="columnheader">
              {TOTAL_COLUNA}
            </span>
            {colunas.map((coluna) => (
              <span key={coluna} className={styles.numero} role="columnheader">
                {coluna}
              </span>
            ))}
            <span aria-hidden="true" />
          </div>
          {linhas.map((linha) => (
            <div
              key={linha.key}
              className={`${styles.linha} ${styles[linha.nivel]}`}
              style={{ gridTemplateColumns: grade }}
              role="row"
              data-testid={linha.testId}
            >
              <span className={styles.coletor} role="cell">
                {linha.expansivel && linha.categoria ? (
                  <Button
                    type="button"
                    text
                    rounded
                    severity="secondary"
                    className="p-button-row-actions"
                    icon={
                      <Icon name={linha.expandida ? "chevron-down" : "chevron-right"} size={14} />
                    }
                    aria-label={`${linha.expandida ? "Recolher" : "Expandir"} ${linha.nome}`}
                    aria-expanded={linha.expandida}
                    onClick={() => linha.categoria && alternarCategoria(linha.categoria)}
                  />
                ) : null}
                <span className={styles.coletorNome}>{linha.nome}</span>
              </span>
              <span className={styles.numero} role="cell">
                {linha.total}
              </span>
              {linha.meses.map((valor, indice) => (
                <span key={colunas[indice]} className={styles.numero} role="cell">
                  {valor}
                </span>
              ))}
              <span aria-hidden="true" />
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
